import styled from 'styled-components'

export const ReceivedLogoContainer = styled.div`
  height: 32px;
  width: 32px;
  animation-duration: 0.3s;
  animation-name: appear;
  margin: 0 8px 0 0;
  background-color: rgba(30, 180, 238, 1);
  border-radius: 50%;
`

export const AvatarImage = styled.img.attrs(() =>({
  'aria-hidden': true
}))`
  height: ${props => props.height || 32}px;
  width: ${props => props.width || 32}px;
  border-radius: 50%;
`
